/**
 * Puts the app back at the top of the page.
 *
 * Which element actually scrolls depends on where you are. Inside the authed
 * shell it is `.shipment-background` (App.css: `height: 100dvh; overflow-y:
 * scroll`) and the window never moves, so `window.scrollTo` on its own is a
 * silent no-op — that's why a sub-screen used to open at whatever offset the
 * screen before it was left at. Public pages (landing, login) do scroll the
 * window. Reset every candidate rather than guessing which shell we're in.
 *
 * Use this instead of `window.scrollTo(0, 0)` anywhere in the app.
 */
export default function scrollAppToTop() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  window.scrollTo(0, 0);
  const shell = document.querySelector('.shipment-background');
  if (shell) shell.scrollTop = 0;
  if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
}
